import {
  DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH,
  DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH,
} from '../constants/documentHtmlPreviewDimensions'

export const getInitialPreviewZoom = () => {
  const halfScreen = window.innerWidth * 0.5

  const calculatedWrapperWidth = Math.max(
    DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH,
    Math.min(DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH, halfScreen),
  )
  const calculatedZoom = calculatedWrapperWidth / DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH

  const minZoom = DOCUMENT_HTML_PREVIEW_IFRAME_MIN_WIDTH / DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH
  const initialZoom = Math.max(minZoom, calculatedZoom)

  if (initialZoom < 0) {
    return 0
  }

  return initialZoom
}
